export default __webpack_public_path__ + "static/media/login-img.45d3b74f.svg";